import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';
import './SuperAdminStyles.css';

// Super admin credentials
const SUPER_ADMIN_EMAIL = 'superadmin@example.com';
const SUPER_ADMIN_PASSWORD = 'superAdminPassword123!';

function SuperAdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Check if credentials match our fixed super admin credentials
    if (email === SUPER_ADMIN_EMAIL && password === SUPER_ADMIN_PASSWORD) {
      try {
        // Try to sign in with Supabase
        const { data, error } = await supabase.auth.signInWithPassword({
          email: email,
          password: password
        });

        if (error) {
          // If Supabase doesn't have the user, we'll still allow login with our fixed credentials
          console.log('Supabase auth failed, but using fixed credentials: ', error.message);
          // Set some authentication state in localStorage as a fallback
          localStorage.setItem('isSuperAdminAuthenticated', 'true');
          navigate('/superadmin/dashboard');
        } else {
          // Successful login with Supabase
          localStorage.setItem('isSuperAdminAuthenticated', 'true');
          navigate('/superadmin/dashboard');
        }
      } catch (err) {
        console.error('Login error:', err);
        // Still navigate if fixed credentials match, even if Supabase has an issue
        localStorage.setItem('isSuperAdminAuthenticated', 'true');
        navigate('/superadmin/dashboard');
      }
    } else {
      setError('Invalid super admin credentials');
    }
    
    setLoading(false);
  };

  return (
    <div className="super-admin-login-container">
      <div className="login-form-wrapper">
        <div className="super-admin-header">
          <img 
            src="https://gjamvfwvqlizginqdfhd.supabase.co/storage/v1/object/public/transport-uploads/WhatsApp%20Image%202025-11-21%20at%2011.57.28%20AM%20(1).jpeg" 
            alt="Nexy App Logo" 
            className="nexy-logo"
          />
          <h1>Super Admin Portal</h1>
          <p>System Administration & Management</p>
        </div>
        
        <div className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Super Admin Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter super admin email"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter super admin password"
                required
              />
            </div>
            
            <button type="submit" disabled={loading} className="super-admin-btn">
              {loading ? 'Authenticating...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
